import type { ActionButtonProps } from './ActionButton.tsx';

interface GroupedButtonsProps {
  hidden: Array<ActionButtonProps>;
  showed: Array<ActionButtonProps>;
}

export const groupButtons = (actions: Array<ActionButtonProps>): GroupedButtonsProps => {
  const buttons: GroupedButtonsProps = { hidden: [], showed: [] };
  actions.forEach(action => {
    action.showAsActionButton ? buttons.showed.push(action) : buttons.hidden.push(action);
  });
  return buttons;
};
